<div class="dashboard-container modern-scroll">
    <!-- 0. V2 PROMO SECTION -->
    <div class="v2-promo-card" (click)="navigate('/v2/dashboard')" matRipple>
        <div class="promo-content">
            <div class="promo-badge">NEW</div>
            <div class="promo-text-group">
                <h3>Kanithan 2.0 is here!</h3>
                <p>Experience the new AI-powered Chat Dashboard.</p>
            </div>
            <mat-icon class="promo-arrow">east</mat-icon>
        </div>
    </div>

    <!-- 1. RESUME JOURNEY / SUMMARY CARD -->
    <div class="summary-card">
        <div class="card-content">
            <!-- Header: Label + Navigator -->
            <div class="card-header-row">
                <span class="card-label">Overall Spending</span>

                <div class="card-month-nav">
                    <button mat-icon-button (click)="changeMonth(-1)">
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                    <span class="nav-date">{{ viewMonthLabel }}</span>
                    <button mat-icon-button (click)="changeMonth(1)">
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </div>

            <!-- Content Row: Split Left/Right -->
            <div class="card-split-row">

                <!-- LEFT: Amount & Status -->
                <div class="info-side">
                    <h2 class="card-total">{{ totalBalance | currency:'INR':'symbol':'1.0-2' }}</h2>

                    <!-- Budget Badge -->
                    <div class="budget-chip" *ngIf="budgetLimit > 0" [class.warn]="isOverLimit"
                        [class.success]="!isOverLimit">
                        <mat-icon>{{ isOverLimit ? 'trending_up' : 'trending_down' }}</mat-icon>
                        <span *ngIf="!isOverLimit">{{ budgetPercentage }}% below limit</span>
                        <span *ngIf="isOverLimit">{{ -budgetPercentage }}% over limit</span>
                    </div>

                    <!-- No Budget State -->
                    <div class="budget-chip no-budget" *ngIf="budgetLimit === 0">
                        <span>No budget set</span>
                    </div>
                </div>

                <!-- RIGHT: Large Action Box (Restored) -->
                <div class="action-box glass-effect" (click)="handleBudgetAction()" matRipple>
                    <div class="action-icon-area">
                        <mat-icon>{{ budgetLimit > 0 ? 'auto_graph' : 'edit' }}</mat-icon>
                    </div>
                    <span class="action-text">{{ budgetLimit > 0 ? 'View Trends' : 'Set Budget' }}</span>
                    <div class="action-btn-white">
                        <mat-icon>arrow_forward</mat-icon>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- Monthly Insight (Contextual) -->
    <!-- Monthly Insight (Contextual: Shows post-26th or for past months) -->
    <app-monthly-report *ngIf="isMonthlyReportVisible" [totalSpent]="monthTotal" [budget]="monthBudget"
        [catTotals]="monthCatTotals" [date]="viewDate">
    </app-monthly-report>

    <!-- 2. TOP SPENDING SECTION -->
    <div class="section-container">
        <h3 class="section-title">Top Spending</h3>
        <div class="stats-row">
            <div class="stat-item glass" *ngFor="let item of topSpends">
                <div class="stat-icon-box" [style.background]="item.color + '20'">
                    <mat-icon [style.color]="item.color">{{ item.icon }}</mat-icon>
                </div>
                <div class="stat-info">
                    <span class="val" [style.color]="item.color">{{ item.amount / 1000 | number:'1.0-1' }}k</span>
                    <span class="lab">{{ item.name }}</span>
                </div>
            </div>

            <!-- Fallback if no data -->
            <div class="stat-item glass" *ngIf="topSpends.length === 0">
                <div class="stat-icon-box bg-purple">
                    <mat-icon>savings</mat-icon>
                </div>
                <div class="stat-info">
                    <span class="val">--</span>
                    <span class="lab">No Data</span>
                </div>
            </div>

            <div class="stat-item glass more-stats" (click)="handleBudgetAction()" matRipple>
                <mat-icon>chevron_right</mat-icon>
            </div>
        </div>
    </div>

    <!-- 3. VALUE ADDED SERVICES / ACTION GRID -->
    <div class="section-container">
        <h3 class="section-title">Quick Actions</h3>
        <div class="action-grid">
            <div class="grid-item" (click)="navigate('family')">
                <div class="grid-icon bg-blue">
                    <mat-icon>group</mat-icon>
                </div>
                <span>Family</span>
            </div>
            <div class="grid-item" (click)="navigate('trips')">
                <div class="grid-icon bg-orange">
                    <mat-icon>flight</mat-icon>
                </div>
                <span>Trips</span>
            </div>
            <div class="grid-item" (click)="navigate('habits')">
                <div class="grid-icon bg-purple">
                    <mat-icon>check_circle</mat-icon>
                </div>
                <span>Habits</span>
            </div>
            <div class="grid-item" (click)="navigate('settings')">
                <div class="grid-icon bg-mint">
                    <mat-icon>settings_backup_restore</mat-icon>
                </div>
                <span>Backup</span>
            </div>
        </div>
    </div>

    <!-- 4. BOTTOM CHART AREA -->
    <div class="chart-section">
        <app-dashboard-chart [totalBalance]="totalBalance" [legendItems]="legendItems">
        </app-dashboard-chart>
    </div>
</div>